module.exports = __webpack_public_path__ + "img/dropdown-v.db15899c.svg";